<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("cinema", 2) }}
      </div>
      <router-link class="btn-blue" to="cinemas"
        >{{ $tc("cinema", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <section v-if="true" class="mb-4 w-100 px-3 section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box new-border"
            style="padding: 6px; align-items: center; border-radius: 10px"
            v-b-toggle.cinemadetails
          >
            <span class="fs">
              {{ $tc("Cinema Details", 2) }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="cinemadetails"
            class="mt-2"
            v-model="sectionCollapse.cinemadetails"
          >
            <div
              class="row pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back"
              style="border-radius: 10px"
            >
              <div
                v-for="(item, index) in Cinemas"
                :key="index"
                v-if="item.fieldname !== 'cine_id'"
                class="col-lg-6 col-xl-4 align-self-center mb-2"
              >
                <div
                  v-if="
                    item.type !== 'radio' &&
                    item.type !== 'dropdown' &&
                    item.type !== 'file'
                  "
                  class="dropdown-curve-container"
                >
                  <div class="d-flex align-items-center">
                    <div class="input-material d-flex align-items-center">
                      <div
                        v-if="item.fieldname === 'cine_phone'"
                        class="col-4 pl-0"
                      >
                        <!--  -->
                        <label :class="SelectedCountryCode ? 'shift-up' : ''">
                          <!-- {{ $t(countrycode) }} -->
                          {{ $t("code") }}
                        </label>
                        <b-dropdown
                          :text="SelectedCountryCode"
                          variant="dropdown-curve"
                          class="w-100 text-center mr-3"
                          placeholder="code"
                          name="countrycode"
                          id="countrycode"
                        >
                          <div class="px-2 pb-2">
                            <input
                              required
                              autofocus
                              type="search"
                              placeholder="Search Code"
                              class="form-control form-control-sm"
                              v-on:keyup="onSearchCode($event.target.value)"
                              v-on:keydown="onSearchCode($event.target.value)"
                              v-on:search="onSearchCode($event.target.value)"
                              v-model="searchCode"
                            />
                          </div>
                          <b-dropdown-item
                            href="#"
                            v-for="(countrycode, countryIndex) in countryList"
                            :key="countryIndex"
                            v-on:click="
                              onSelectHandler('countrycode', countrycode)
                            "
                            v-if="countrycode.country_mob_code != null"
                            >{{ countrycode.country_mob_code }}</b-dropdown-item
                          >
                        </b-dropdown>
                        <!--  -->
                      </div>

                      <div class="position-relative w-100">
                        <input
                          @focus="onFocusHandler"
                          :type="item.type"
                          :name="item.fieldname"
                          :id="item.fieldname"
                          v-validate="item.validation"
                          v-model="item.fieldvalue"
                          placeholder="."
                          v-b-tooltip.hover
                          :title="$t(item.tooltip)"
                          @input="onChangeInput($event, item)"
                        />
                        <label>{{ $tc(item.label, 1) }}</label>
                      </div>
                    </div>
                    <!--Tooltip :title="$t(item.tooltip)" /--->
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has(item.fieldname)">{{
                      errors.first(`${item.fieldname}`)
                    }}</span>
                  </p>
                </div>

                <div
                  v-if="item.type === 'radio'"
                  class="d-flex align-items-center"
                >
                  <label class="mb-0 mr-3">{{ $tc(item.label, 1) }}</label>
                  <label class="mb-0">
                    <b-form-checkbox
                      type="checkbox"
                      class="j-checkbox mb-0"
                      v-model="item.fieldvalue"
                    />
                    <span class="switch-slider"></span>
                  </label>
                </div>

                <div
                  v-if="
                    item.type === 'file' && item.fieldname === 'cine_image_url'
                  "
                >
                  <div class="d-flex align-items-center">
                    <label :for="item.fieldname" class="file-selector w-100">
                      <label
                        class="file-selector-label"
                        :class="
                          item.fieldvalue && item.fieldvalue.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc(item.label, 1) }}</label
                      >
                      <span class="text-truncate">{{ item.fieldvalue }}</span>
                      <input
                        :type="item.type"
                        :name="item.fieldname"
                        :id="item.fieldname"
                        placeholder="."
                        class="d-none"
                        v-on:change="setImage($event, index)"
                        v-b-tooltip.hover
                        :title="$t(item.tooltip)"
                      />
                    </label>
                    <div class="col-2 align-self-center">
                      <img
                        width="40"
                        height="40"
                        class="rounded"
                        @click="showImage()"
                        :src="_GetImagePath(item.fieldvalue)"
                        v-if="item.fieldvalue && item.fieldvalue.length > 0"
                      />
                      <img
                        v-else
                        width="35"
                        height="35"
                        class="rounded"
                        alt="Empty Image"
                        src="@/assets/img/icons/empty-image.svg"
                        v-b-tooltip.hover.top="item.tooltip"
                      />
                    </div>
                    <!--Tooltip :title="$t(item.tooltip)" /--->
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && item.fieldvalue.length == 0"
                      >Please upload an image.</span
                    >
                  </p>
                </div>

                <div v-if="item.type === 'dropdown'">
                  <!-- ORAGNIZATION DROPDONW  -->
                  <div
                    class="dropdown-curve-container"
                    v-if="item.fieldname === 'org_id'"
                  >
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                        name="org"
                        id="org"
                      >
                        <!-- _getCountryList(item.label, null) -->
                        <b-dropdown-item
                          v-for="(
                            dropdownItem, dropdownIndex
                          ) in organizationList"
                          :key="dropdownIndex"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          v-b-tooltip.hover
                          :title="$t(item.tooltip)"
                          >{{ dropdownItem.org_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <!--Tooltip :title="$t(item.tooltip)" /-->
                    </div>
                    <!-- {{ item.dropdownSelected.length == 0 }} -->
                    <p class="error_message">
                      <span
                        v-if="submitted && item.dropdownSelected.length == 0"
                        >Please Select Organization.</span
                      >
                    </p>
                  </div>
                </div>
                <!-- enddddddddd -->
                <!-- CINEMA TYPE DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'cinema_type_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      name="cinema_type"
                      id="cinema_type"
                    >
                      <!-- _getCountryList(item.label, null) -->
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in cinemaTypesList"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        v-b-tooltip.hover
                        :title="$t(item.tooltip)"
                        >{{ dropdownItem.cinema_type_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!--Tooltip :title="$t(item.tooltip)" /-->
                  </div>
                  <p class="error_message">
                    <!-- <span v-if="submitted && item.dropdownSelected.length == 0">Please Select Cinema Type.</span> -->
                  </p>
                </div>

                <!-- CURRENCY DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'currency_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      name="curr"
                      id="curr"
                    >
                      <!-- _getCountryList(item.label, null) -->
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in currency"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        v-b-tooltip.hover
                        :title="$t(item.tooltip)"
                        >{{ dropdownItem.curr_code }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!--Tooltip :title="$t(item.tooltip)" /-->
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && item.dropdownSelected.length == 0"
                      >Please Select Currency.</span
                    >
                  </p>
                </div>
                <!-- COUNTRY DROPDONW -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'country_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <!-- <b-dropdown
                :text="item.dropdownSelected"
                variant="dropdown-curve"
                class="w-100"
                name="coun"
                id="coun"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in countryList"
                  :key="dropdownIndex"
                  @click="onDropdownChange($event, item.label, dropdownItem, index)"
                >{{ dropdownItem.country_name }}</b-dropdown-item>
              </b-dropdown>-->
                    <multiselect
                      :options="countryList"
                      v-model="selected_country"
                      :searchable="true"
                      label="country_name"
                      track-by="country_name"
                      placeholder="."
                      @input="
                        onDropdownChange(
                          $event,
                          item.label,
                          selected_country,
                          index
                        )
                      "
                      :allowEmpty="false"
                      :showLabels="false"
                      v-b-tooltip.hover
                      :title="$t(item.tooltip)"
                    ></multiselect>
                    <!--Tooltip :title="$t(item.tooltip)" /-->
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && item.dropdownSelected.length == 0"
                      >Please Select Country.</span
                    >
                  </p>
                </div>

                <!-- STATE DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'state_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <!-- <b-dropdown
                :text="item.dropdownSelected"
                variant="dropdown-curve"
                class="w-100"
                name="state"
                id="state"
              >

                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in stateList"
                  :key="dropdownIndex"
                  @click="onDropdownChange($event, item.label,dropdownItem, index)"
                >{{ dropdownItem.state_name }}</b-dropdown-item>
              </b-dropdown>-->
                    <multiselect
                      :options="stateList"
                      v-model="selected_state"
                      :searchable="true"
                      label="state_name"
                      track-by="state_name"
                      placeholder="."
                      :allowEmpty="true"
                      :showLabels="false"
                      @input="
                        onDropdownChange(
                          $event,
                          item.label,
                          selected_state,
                          index
                        )
                      "
                      v-b-tooltip.hover
                      :title="$t(item.tooltip)"
                    ></multiselect>
                    <!--Tooltip :title="$t(item.tooltip)" /-->
                  </div>
                  <p class="error_message">
                    <!-- <span v-if="submitted && item.dropdownSelected.length == 0"
                >Please Select State.</span
              > -->
                  </p>
                </div>
                <!-- CITY DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'city_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <!-- <b-dropdown
                :text="item.dropdownSelected"
                variant="dropdown-curve"
                class="w-100"
                name="city"
                id="city"
              >

                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in cityList"
                  :key="dropdownIndex"
                  @click="onDropdownChange($event, item.label,dropdownItem, index)"
                >{{ dropdownItem.city_name }}</b-dropdown-item>
              </b-dropdown>-->
                    <multiselect
                      :options="cityList"
                      v-model="selected_city"
                      :searchable="true"
                      label="city_name"
                      track-by="city_name"
                      placeholder="."
                      :allowEmpty="true"
                      :showLabels="false"
                      @input="
                        onDropdownChange(
                          $event,
                          item.label,
                          selected_city,
                          index
                        )
                      "
                      v-b-tooltip.hover
                      :title="$t(item.tooltip)"
                    ></multiselect>
                    <!--Tooltip :title="$t(item.tooltip)" /--->
                  </div>
                  <!--<p class="error_message">
              <span v-if="submitted && item.dropdownSelected.length == 0"
                >Please Select City.</span
              >
            </p>-->
                </div>

                <!-- TERRITORY DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'territory_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      name="territory"
                      id="territory"
                    >
                      <!-- _getCountryList(item.label, null) -->
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in territoryList"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        v-b-tooltip.hover
                        :title="$t(item.tooltip)"
                        >{{ dropdownItem.territory_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!--Tooltip :title="$t(item.tooltip)" /-->
                  </div>
                  <p class="error_message">
                    <!-- <span v-if="submitted && item.dropdownSelected.length == 0">Please Select Territory.</span> -->
                  </p>
                </div>

                <!-- REGION DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'region_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      name="region"
                      id="region"
                    >
                      <!-- _getCountryList(item.label, null) -->
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in regionList"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        v-b-tooltip.hover
                        :title="$t(item.tooltip)"
                        >{{ dropdownItem.region_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!--Tooltip :title="$t(item.tooltip)" /-->
                  </div>
                  <p class="error_message">
                    <!-- <span v-if="submitted && item.dropdownSelected.length == 0">Please Select Region.</span> -->
                  </p>
                </div>

                <!-- LOCATION TYPE DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'location_type_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      name="region"
                      id="region"
                    >
                      <!-- _getCountryList(item.label, null) -->
                      <b-dropdown-item
                        v-for="(
                          dropdownItem, dropdownIndex
                        ) in locationTypesList"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        v-b-tooltip.hover
                        :title="$t(item.tooltip)"
                        >{{ dropdownItem.location_type_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!--Tooltip :title="$t(item.tooltip)" /-->
                  </div>
                  <p class="error_message">
                    <!-- <span
                v-if="submitted && item.dropdownSelected.length == 0"
              >Please Select Location Type.</span>-->
                  </p>
                </div>

                <!-- CINEMA CLASSIFICATION DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'cinema_classification_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      name="region"
                      id="region"
                    >
                      <b-dropdown-item
                        v-for="(
                          dropdownItem, dropdownIndex
                        ) in cineClassificationList"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        v-b-tooltip.hover
                        :title="$t(item.tooltip)"
                        >{{
                          dropdownItem.cine_classification_name
                        }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!--Tooltip :title="$t(item.tooltip)" /-->
                  </div>
                  <p class="error_message">
                    <!-- <span
                v-if="submitted && item.dropdownSelected.length == 0"
              >Please Select Location Type.</span>-->
                  </p>
                </div>

                <!-- TIER DROPDOWN -->
                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'tier_type_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      name="region"
                      id="region"
                    >
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in tierTypeList"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        v-b-tooltip.hover
                        :title="$t(item.tooltip)"
                        >{{ dropdownItem.tier_type_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!--Tooltip :title="$t(item.tooltip)" /-->
                  </div>
                  <p class="error_message">
                    <!-- <span
                v-if="submitted && item.dropdownSelected.length == 0"
              >Please Select Location Type.</span>-->
                  </p>
                </div>

                <div
                  class="dropdown-curve-container"
                  v-if="item.fieldname === 'preferred_language_id'"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <label
                      :class="
                        item.dropdownSelected &&
                        item.dropdownSelected.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <multiselect
                      :options="ActiveLanguages"
                      v-model="selectedPreferredLang"
                      :searchable="true"
                      label="lang_name"
                      track-by="lang_id"
                      placeholder="."
                      @input="
                        onDropdownChange(
                          $event,
                          item.label,
                          selectedPreferredLang,
                          index
                        )
                      "
                      :allowEmpty="false"
                      :showLabels="false"
                    ></multiselect>
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && item.dropdownSelected.length == 0"
                      >Please Select Preferred Language.</span
                    >
                  </p>
                </div>

                <!-- <div
            v-if="item.fieldname === 'cine_image_url'"
            class="col-lg-6 col-xl-4 align-self-center mb-4"
          >
            <div class="d-flex align-items-center">
              <label for="file-selector" class="file-selector w-100">
                <label
                  class="file-selector-label"
                  :class="user_profile_image_url.length > 0 ? 'shift-up' : ''"
                >{{ $t('uploaduserimage') }}</label>
                <span>{{user_profile_image_url}}</span>
                <input
                  v-on:change="uploadImage($event)"
                  type="file"
                  class="d-none"
                  id="file-selector"
                />
              </label>

              <Tooltip :title="Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg" />
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>-->

                <!-- Language DROPDONW  -->
                <!-- <div v-if="item.type === 'dropdown'">
              <div
                class="dropdown-curve-container"
                v-if="item.fieldname === 'cine_application_language_id'"
              >
                <label
                  :class="item.dropdownSelected.length > 0 ? 'shift-up' : '' "
                >{{ $tc(item.label, 1) }}</label>
                <div class="d-flex justify-content-center align-items-center">
                  <b-dropdown
                    :text="item.dropdownSelected"
                    variant="dropdown-curve"
                    class="w-100"
                    name="lang"
                    id="lang"
                  >
                    <b-dropdown-item
                      v-for="(dropdownItem,dropdownIndex) in language"
                      :key="dropdownIndex"
                      @click="onDropdownChange($event, item.label, dropdownItem, index)"
                    >{{ dropdownItem.lang_name }}</b-dropdown-item>
                  </b-dropdown>
                  <Tooltip :title="$t(item.tooltip)" />
                </div>
                <p
                  v-if="submitted && item.dropdownSelected.length == 0"
                  class="error_message"
                >Please Select Language.</p>
              </div>
          </div>-->
              </div>
            </div>
          </b-collapse>
        </section>

        <!-- CUSTOM FIELDS SECTION -->
        <section class="mb-4 col-12" v-if="custom_fields_list.length > 0">
          <div class="section-title mb-4">Custom Field</div>
          <form v-if="custom_fields_list" class="row">
            <div
              v-for="(field, fieldKey) in custom_fields_list"
              :key="fieldKey"
              class="col-lg-6 col-xl-4 mb-4"
            >
              <div v-if="field.custom_field_type == 'text'">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      :minlength="field.min_length"
                      :maxlength="field.max_length"
                      type="text"
                      name="text_input"
                      v-model="input_data[fieldKey]"
                      placeholder="."
                    />
                    <label
                      :class="
                        input_data[fieldKey] !== undefined &&
                        input_data[fieldKey].length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ field.custom_field_name }}</label
                    >
                  </div>
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      (input_data[fieldKey] === undefined ||
                        input_data[fieldKey] == '') &&
                      field.field_is_required == 'Y'
                    "
                    >Please Select {{ field.custom_field_name }}</span
                  >
                </p>
              </div>
              <div v-if="field.custom_field_type == 'textarea'">
                <div class="d-flex align-items-center">
                  <div class="input-material-textarea">
                    <textarea
                      :minlength="field.min_length"
                      :maxlength="field.max_length"
                      name="text_area"
                      v-model="input_data[fieldKey]"
                    ></textarea>
                    <label
                      :class="
                        input_data[fieldKey] != undefined &&
                        input_data[fieldKey].length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ field.custom_field_name }}</label
                    >
                  </div>
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      (input_data[fieldKey] === undefined ||
                        input_data[fieldKey] == '') &&
                      field.field_is_required == 'Y'
                    "
                    >Please Select {{ field.custom_field_name }}</span
                  >
                </p>
              </div>
              <div v-if="field.custom_field_type == 'number'">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      type="number"
                      :minlength="field.min_length"
                      :maxlength="field.max_length"
                      name="number"
                      :placeholder="field.custom_field_name"
                      v-model="input_data[fieldKey]"
                    />
                    <label
                      :class="
                        input_data[fieldKey] != undefined &&
                        input_data[fieldKey].length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >{{ field.custom_field_name }}</label
                    >
                  </div>
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      submitted &&
                      (input_data[fieldKey] === undefined ||
                        input_data[fieldKey] == '') &&
                      field.field_is_required == 'Y'
                    "
                    >Please Select {{ field.custom_field_name }}</span
                  >
                </p>
              </div>
              <div
                v-if="field.custom_field_type == 'checkbox'"
                class="d-flex align-items-center"
              >
                <label class="mr-2">{{ field.custom_field_name }}</label>
                <b-form-checkbox
                  name="check-button"
                  switch
                  v-model="input_data[fieldKey]"
                ></b-form-checkbox>
              </div>

              <div
                v-if="field.custom_field_type == 'rating'"
                class="d-flex align-items-center"
              >
                <label class="mr-2">{{ field.custom_field_name }}</label>
                <star-rating v-model="rating"></star-rating>
              </div>

              <!-- <p class="error_message">{{errorMessage}}</p> -->
            </div>

            <!-- <div class="col-md-12 text-center">
              <button @click.prevent.stop="submit" class="btn-blue">{{ $t('submit') }}</button>
            </div>-->
          </form>
        </section>

        <section class="my-3 w-100 px-3 distributor-section-new">
          <div
            class="section-title d-flex justify-content-between section-border section-border"
            v-b-toggle.transalations
            style="padding: 6px; align-items: center"
          >
            <span class="fs">
              {{ "Translations" }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="transalations"
            class="mt-2 translationContainer"
            v-model="sectionCollapse.transalations"
          >
            <div class="bn-tabs-nav">
              <button
                v-for="(content, contentIndex) in langContent"
                :key="contentIndex"
                :class="[
                  'btn-tab-title ',
                  { active: contentIndex == activeClass },
                ]"
                @click.prevent.stop="onChangeTabHandler($event, contentIndex)"
              >
                <strong>
                  <span
                    :class="
                      content.langauge.toLowerCase() !== 'english'
                        ? notempty[contentIndex]
                          ? ''
                          : 'text-danger'
                        : ''
                    "
                    >{{ content.langauge }}</span
                  >
                </strong>
              </button>
            </div>

            <div class="bn-tabs-content p-3">
              <div
                v-for="(content, contentIndex) in langContent"
                :key="contentIndex"
              >
                <div v-if="contentIndex === activeClass">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="content.cinema_name"
                            placeholder="."
                            name="cinema_name"
                            id="cinema_name"
                            maxlength="200"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                'cine_name',
                                contentIndex
                              )
                            "
                          />
                          <label :class="content.cinema_name ? 'shift-up' : ''"
                            >Cinema Name</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="content.cinema_address"
                            placeholder="."
                            name="cinema_name"
                            id="cinema_name"
                            maxlength="200"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                'cine_address',
                                contentIndex
                              )
                            "
                          />
                          <label
                            :class="content.cinema_address ? 'shift-up' : ''"
                            >Cinema Address</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="content.cinema_location"
                            placeholder="."
                            name="cinema_name"
                            id="cinema_name"
                            maxlength="200"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                'cine_location',
                                contentIndex
                              )
                            "
                          />
                          <label
                            :class="content.cinema_location ? 'shift-up' : ''"
                            >Cinema Location</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-2">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="content.company_name"
                            placeholder="."
                            name="company_name"
                            id="company_name"
                            maxlength="200"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                'company_name',
                                contentIndex
                              )
                            "
                          />
                          <label :class="content.company_name ? 'shift-up' : ''"
                            >Company Name</label
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-lg-12 align-self-center mb-4 descriptionEditor"
                    >
                      <div
                        class="descriptionSection font-weight-bold fs-14 mb-3"
                      >
                        Description
                      </div>
                      <div class="" v-if="content.isEdit">
                        <vue-editor
                          v-model="content.cinema_description"
                          name="page"
                          id="page"
                        ></vue-editor>
                      </div>
                      <div
                        class="input-material-textarea"
                        v-else-if="content.isEditHtml && !content.isEdit"
                      >
                        <textarea
                          id="htmlContent"
                          name="htmlContent"
                          v-model="content.cinema_description"
                          placeholder="Description"
                          class="htmlContent"
                        />
                      </div>
                      <div class="ql-snow" v-else>
                        <div
                          class="ql-editor"
                          v-html="content.cinema_description"
                          v-if="content.cinema_description"
                        ></div>
                        <div
                          class="ql-editor text-center"
                          v-else
                          style="min-height: 33px"
                        >
                          No Content
                        </div>
                      </div>
                      <vue-editor style="display: none" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="cinemas">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>

    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      title="Cinema image"
      id="selected-image-preview-modal"
    >
      <img :src="_GetImagePath(Cinemas[30].fieldvalue)" class="img-fluid" />
    </b-modal>

    <b-modal id="imagecropper" hide-header hide-footer no-close-on-backdrop>
      <label class="h4 text-center">Crop Image</label>
      <button
        class="btn-clearDate float-right"
        v-on:click="hideCropperModal('imagecropper')"
      >
        ✖
      </button>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :autoCrop="true"
        :autoCropWidth="350"
        :autoCropHeight="220"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <!-- aspectratiot:175/175 -->
      <br />
      <div class="text-center">
        <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import Cinemas from "@/helper/formJSONMaster/Cinemas";
import CinemaService from "@/services/CinemasService";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { VueEditor } from "vue2-editor";
import Tooltip from "@/components/UIElements/Tooltip.vue";
import ExhibitorService from "@/services/ExhibitorService";
import _ from "lodash";

export default {
  components: { VueCropper, Tooltip, VueEditor },
  data() {
    return {
      sectionCollapse: {
        transalations: true,
        cinemadetails: true,
      },
      langContent: [],
      Languages: [],
      ContentLanguages: [],
      activeClass: 0,
      notempty: [false, false, false, false, false, false],
      btenable: false,
      // org: "Select Organiztion",
      // curr: "Select Currency",
      // coun: "Select Country",
      // state: "Select State",
      // city: "Select City",
      errmsg: "",
      Cinemas: Cinemas.ms_cinemas,
      submitted: false,
      Methods: Cinemas.Methods,
      countryList: [],
      CodeListCopy: [],
      stateList: [],
      cityList: [],
      organizationList: [],
      ActiveLanguages: [],
      currency: [],
      regionList: [],
      cinemaTypesList: [],
      territoryList: [],
      locationTypesList: [],
      cineClassificationList: [],
      tierTypeList: [],
      custom_fields_list: [],
      input_data: [],
      selected_country: null,
      selected_state: null,
      selected_city: null,
      SelectedCountryCode: "",
      selectedPreferredLang: null,
      // user_profile_image_url: "",
      file: "",
      imgSrc: "",
      cropImg: "",
      filename: "",
      indexofthubmnail: "",
      searchCode: "",
      // language: []
    };
  },
  beforeMount() {
    this.getCountryList();
    this.getOrgList();
    this.getCurrencyList();
    this.resetHandler();
    this.getRegions();
    this.getCinemaTypes();
    // this.getTerritories();
    this.getTerritoryData();
    this.getLocationTypes();
    this.getCineClassification();
    this.getTierType();
    this.getCustomFields();
    // this.getlanguagelist();
    this.getActiveLanguages();
    this.getContentLanguage();
  },
  mounted() {},
  methods: {
    CheckEmptyContent: function (content, langIndex) {
      if (
        content.cinema_name &&
        content.cinema_address &&
        content.cinema_location
      ) {
        this.notempty[langIndex] = true;
      } else {
        this.notempty[langIndex] = false;
      }
    },
    onChangeInput(event, item) {
      let index =
        this.langContent.findIndex(
          (x) => x.langauge.toLowerCase() == "english"
        ) || 0;
      if (item.fieldname == "cine_name") {
        this.langContent[index].cinema_name = event.target.value;
      } else if (item.fieldname == "cine_address") {
        this.langContent[index].cinema_address = event.target.value;
      } else if (item.fieldname == "cine_location") {
        this.langContent[index].cinema_location = event.target.value;
      } else if (item.fieldname == "company_name") {
        this.langContent[index].company_name = event.target.value;
      }
    },
    onChangeTranslationInput(event, content, item, contentIndex) {
      let index =
        this.Cinemas.findIndex((x) => x.fieldname.toLowerCase() == item) || 0;
      if (index && content.langauge.toLowerCase() == "english") {
        this.Cinemas[index].fieldvalue = event.target.value;
      }
      this.CheckEmptyContent(content, contentIndex);
    },
    onChangeTabHandler: function (event, index) {
      this.activeClass = index;
    },
    getContentLanguage: function () {
      MovieService.GetMovieContentLanguages()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              this.ContentLanguages = data.ContentLanguages;
            }
          } else {
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers();
        })
        .catch((error) => {});
    },
    makeLangContainers: function () {
      this.ContentLanguages.map((x) => {
        let Obj = {
          ...x,
          cinema_name: "",
          cinema_address: "",
          cinema_location: "",
          company_name: "",
          cinema_description: "",
          isEdit: true,
          isEditHtml: false,
        };
        this.langContent.push(Obj);
        console.log("this.langContent", this.langContent);
      });
    },
    showImage: function () {
      this.$refs["preview-modal"].show();
    },
    hideCropperModal: function (modal) {
      this.$bvModal.hide("imagecropper");
    },
    setImage: function (e, index) {
      this.file = e.target.files[0];
      this.filename = e.target.files[0]["name"];
      this.indexofthubmnail = index;

      if (this.file.type.indexOf("image/") === -1) {
        this.$toasted.show("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          this.$bvModal.show("imagecropper");
          e.target.value = "";
        };
        reader.readAsDataURL(this.file);
      } else {
        // alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      this.$bvModal.hide("imagecropper");
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
    },

    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    onThumbnailUpload: function (image, filename, index) {
      let loader = this.$loading.show();

      let formData = new FormData();
      // formData.append("image", image);
      formData.append("image", image, filename);
      formData.append("imagePath", "Cinema Image");
      MasterService.GlobalUploadImage(formData)
        .then((response) => {
          // console.log("response :", response);
          const { data } = response;
          if (data && data.status) {
            this.Cinemas[index].fieldvalue = data.path;
            this.imgSrc = "";
            this.$bvModal.hide("imagecropper");
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    onSelectHandler(type, value, index) {
      if (type == "countrycode") {
        this.SelectedCountryCode = value.country_mob_code;
      }
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    getCustomFields: function () {
      let payload = {
        table_name: "ms_cinemas",
      };
      MasterService.getCustomFields(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.custom_fields_list = _.sortBy(data.Records, ["order_id"]);
            this.custom_fields_list.map((field, index) => {
              if (field.custom_field_type == "checkbox") {
                this.input_data[index] =
                  this.input_data[index] == undefined
                    ? false
                    : this.input_data[index];
              }
            });
            console.log(
              "this.custom_fields_list :>> ",
              this.custom_fields_list
            );
          } else {
            // Show Errors
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.Cinemas.map((x) => {
        if (
          x.type === "text" ||
          x.type === "date" ||
          x.type === "file" ||
          x.type === "number" ||
          x.type === "email"
        ) {
          x.fieldvalue = "";
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
      this.SelectedCountryCode = "";
    },
    getStateList: function (id) {
      this.stateList = [];
      this.cityList = [];
      let payload = {
        tableName: "ms_states",
        state_is_active: "Y",
        country_id: id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // this.stateList = data.Records;
            this.stateList = data.Records.sort((a, b) =>
              a.state_name.localeCompare(b.state_name)
            );

            this.Cinemas.map((x) => {
              if (x.fieldname === "state_id") {
                x.dropdownSelected = "";
                x.fieldvalue = "";
              }
            });
          } else {
            // Show Errors
            // console.log("show error :", data.message);
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCityList: function (id) {
      this.cityList = [];

      let payload = {
        tableName: "ms_cities",
        city_is_active: "Y",
        state_id: id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cityList = data.Records;
            this.Cinemas.map((x) => {
              if (x.fieldname === "city_id") {
                x.dropdownSelected = "";
                x.fieldvalue = "";
              }
            });
          } else {
            // Show Errors
            // console.log("show error :", data.message);
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    // getlanguagelist: function() {
    //   this.language = [];
    //   let payload = {
    //     tableName: "ms_language",
    //     lang_is_active: "Y"
    //   };
    //   MasterService.GetActiveList(payload)
    //     .then(response => {
    //       const { data } = response;
    //       if (data.status && data.Records.length > 0) {
    //         this.language = data.Records;
    //         // console.log(this.language);
    //       } else {
    //         console.log("show error1 :", data.message);
    //       }
    //     })
    //     .catch(error => {
    //       console.log("show error2 :", error);
    //     });
    // },
    getCountryList: function () {
      this.stateList = [];
      this.countryList = [];
      this.CodeListCopy = [];
      this.cityList = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // this.countryList = data.Records;
            // this.CodeListCopy = data.Records;
            const sortedCountries = data.Records.sort((a, b) =>
              a.country_name.localeCompare(b.country_name)
            );

            this.countryList = sortedCountries;
            this.CodeListCopy = sortedCountries;
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getRegions: function () {
      let payload = {
        tableName: "ms_regions",
        region_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              // this.regionList = data.Records;
              this.regionList = data.Records.sort((a, b) =>
                a.region_name.localeCompare(b.region_name)
              );
            }
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCinemaTypes: function () {
      let payload = {
        tableName: "ms_cinema_types",
        cine_type_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaTypesList = data.Records;
            console.log("this.cinemaTypesList :>> ", this.cinemaTypesList);
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    // getTerritories: function () {
    //   let payload = {
    //     tableName: "ms_territories",
    //     territory_is_active: "Y",
    //   };
    //   MasterService.GetActiveList(payload)
    //     .then((response) => {
    //       const { data } = response;
    //       if (data.status && data.Records.length > 0) {
    //         this.territoryList = data.Records;
    //         console.log("this.territoryList :>> ", this.territoryList);
    //       } else {
    //         console.log("show error1 :", data.message);
    //         // this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(this._CatchError);
    // },

    getTerritoryData() {
      // this.pp_type_id = item.pp_type_id;
      // this.is_active = item.is_active;
      let payload = {
        territory_is_active: "Y",
        // pp_type_id: this.pp_type_id,
        // is_active: this.is_active,
      };
      ExhibitorService.GetTerritoryData(payload)
        .then((response) => {
          const { data } = response;

          if (data.Records.length > 0) {
            console.log(data.Records);
            let territoryData = data.Records;
            this.territoryList = territoryData;
          } else {
            this.territoryList = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getLocationTypes: function () {
      let payload = {
        tableName: "ms_location_types",
        location_type_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.locationTypesList = data.Records;
            console.log("this.locationTypesList :>> ", this.locationTypesList);
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCineClassification: function () {
      let payload = {
        tableName: "ms_cinema_classification",
        cine_classification_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cineClassificationList = data.Records;
            console.log(
              "this.cineClassificationList :>> ",
              this.cineClassificationList
            );
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getTierType: function () {
      let payload = {
        tableName: "ms_tier_type",
        tier_type_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.tierTypeList = data.Records;
            console.log("this.tierTypeList :>> ", this.tierTypeList);
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getOrgList: function () {
      let payload = {
        tableName: "organizations",
        org_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.organizationList = data.Records;
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCurrencyList: function () {
      this.currency = [];
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.currency = data.Records;
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onDropdownChange: function (event, type, item, mainIndex) {
      if (type === "country") {
        this.Cinemas[mainIndex].fieldvalue = item.country_id;
        this.Cinemas[mainIndex].dropdownSelected = item.country_name;
        this.selected_state = null;
        this.selected_city = null;
        this.SelectedCountryCode = item.country_mob_code;
        this.getStateList(item.country_id);
        this.setDropdownHandler(["state", "city"]);
      } else if (type === "state") {
        this.Cinemas[mainIndex].dropdownSelected = item.state_name;
        this.Cinemas[mainIndex].fieldvalue = item.state_id;
        this.selected_city = null;

        this.getCityList(item.state_id);
        this.setDropdownHandler(["city"]);
      } else if (type === "city") {
        this.Cinemas[mainIndex].dropdownSelected = item.city_name;
        this.Cinemas[mainIndex].fieldvalue = item.city_id;
      } else if (type === "territory") {
        this.Cinemas[mainIndex].dropdownSelected = item.territory_name;
        this.Cinemas[mainIndex].fieldvalue = item.territory_id;
      } else if (type === "region") {
        this.Cinemas[mainIndex].dropdownSelected = item.region_name;
        this.Cinemas[mainIndex].fieldvalue = item.region_id;
      } else if (type === "cinema_type") {
        this.Cinemas[mainIndex].dropdownSelected = item.cinema_type_name;
        this.Cinemas[mainIndex].fieldvalue = item.cinema_type_id;
      } else if (type === "cinema_classification") {
        this.Cinemas[mainIndex].dropdownSelected =
          item.cine_classification_name;
        this.Cinemas[mainIndex].fieldvalue = item.cinema_classification_id;
      } else if (type === "tier_type") {
        this.Cinemas[mainIndex].dropdownSelected = item.tier_type_name;
        this.Cinemas[mainIndex].fieldvalue = item.tier_type_id;
      } else if (type === "location_type") {
        this.Cinemas[mainIndex].dropdownSelected = item.location_type_name;
        this.Cinemas[mainIndex].fieldvalue = item.location_type_id;
      } else if (type === "organization") {
        this.Cinemas[mainIndex].dropdownSelected = item.org_name;
        this.Cinemas[mainIndex].fieldvalue = item.org_id;
      } else if (type === "currency") {
        this.Cinemas[mainIndex].dropdownSelected = item.curr_code;
        this.Cinemas[mainIndex].fieldvalue = item.curr_id;
      } else if (type === "preferred_language_id") {
        this.Cinemas[mainIndex].dropdownSelected = item.lang_name;
        this.Cinemas[mainIndex].fieldvalue = item.lang_id;
      }
      // else if (type === "language") {
      //   this.Cinemas[mainIndex].dropdownSelected = item.lang_name;
      //   this.Cinemas[mainIndex].fieldvalue = item.lang_id;
      // }
    },
    setDropdownHandler: function (resetList) {
      this.Cinemas.map((y) => {
        let array = resetList.filter((x) => `${x}_id` == y.fieldname);
        if (array.length > 0) {
          y.dropdownSelected = ``;
          y.fieldvalue = "";
        }
      });
    },
    getActiveLanguages() {
      let body = {
        tableName: "ms_language",
        lang_is_active: "Y",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveLanguages = data.Records;
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    async handleSubmit(flag) {
      let flagcustomfield = true;
      let input = [];
      this.custom_fields_list.map((field, index) => {
        if (field.field_is_required == "Y") {
          if (
            (this.input_data[index] == undefined ||
              this.input_data[index] == "") &&
            this.input_data[index] !== false
          ) {
            console.log({
              index,
              field,
              "input_data[index]": this.input_data[index],
            });
            // this.errorMessage = "please fill in all required fields";

            flagcustomfield = false;
            return;
          }
        }
      });
      this.submitted = true;
      console.log("this.Cinemas :>> ", this.Cinemas);
      this.$validator.validate().then((valid) => {
        if (this.Cinemas[8].fieldvalue == "") {
          console.log("invalid field", 8, this.Cinemas[8]);
          return;
        }
        if (this.Cinemas[13].fieldvalue == "") {
          console.log("invalid field", 13, this.Cinemas[13]);
          return;
        }
        // "state_id" field
        // if (this.Cinemas[14].fieldvalue == "") {
        //   console.log('invalid field', 14, this.Cinemas[14])
        //   return;
        // }
        // "city_id" field
        // if (this.Cinemas[15].fieldvalue == "") {
        //   console.log('invalid field', 15, this.Cinemas[15])
        //   return;
        // }

        // "cine_image_url"
        if (this.Cinemas[28].fieldvalue == "") {
          console.log("invalid field", 28, this.Cinemas[28]);
          return;
        }
        if (valid) {
          if (flagcustomfield) {
            let loader = this.$loading.show();

            for (let i in this.custom_fields_list) {
              input.push({
                custom_field_id: this.custom_fields_list[i].custom_field_id,
                input_data: this.input_data[i],
              });
            }

            // this.langContent.forEach((x) => {
            //     x.cinema_description = _.unescape(x.cinema_description)
            //   })


              // x.cinema_description = x.cinema_description.replace(/</g, "&lt;").replace(/>/g, "&gt;");
            this.btenable = true;
            this.Cinemas.map((x) => {
              if (x.dropdownSelected == "") {
                x.dropdownSelected = null;
                x.fieldvalue = null;
              }
            });
            let body = this.getRequestBody("POST", this.Cinemas, this.Methods);
            body.payload["translation_data"] = JSON.stringify(this.langContent);
            body.payload.cine_mobile_code =
              this.SelectedCountryCode == "" ? null : this.SelectedCountryCode;
            MasterService.GlobalRequest(body)
              .then(async (response) => {
                this.btenable = false;
                const { data } = response;
                if (data.status) {
                  await CinemaService.InsertCustomFieldValues({
                    custom_field_values: input,
                    table_id: data.insertId,
                  })
                    .then(async (response) => {
                      loader.hide();
                      this.btenable = false;
                      const { data } = response;
                      if (data.status) {
                        this.resetHandler();
                        this.$toasted.show(
                          data.message || "Saved Successfully",
                          {
                            type: "success",
                          }
                        );
                        if (flag) {
                          this.$router.push({
                            path: "/cinema-manager/cinemas",
                          });
                        }
                        this.submitted = false;
                      } else {
                        this.$toasted.show(data.message);
                      }
                    })
                    .catch(this._CatchError);
                  // this.resetHandler();
                  // if (flag) {
                  //   this.$router.push({
                  //     path: "/cinema-manager/cinemas"
                  //   });
                  // }
                  // this.submitted = false;
                } else {
                  this.$toasted.show(data.message);
                  loader.hide();
                }
              })
              .catch(this._CatchError); //message
          } else {
            this.$toasted.show("Please Enter Custom Field details");
          }
        }
      });
      // }
    },
  },
};
</script>
<style>
#imagecropper .btn-clearDate {
  margin-top: -10px;
  margin-right: -10px;
  font-size: 19px;
}
.back-text {
  /* color: #3876d2 !important; */
}

.translationContainer {
  background: rgba(211, 211, 211, 0.2);
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemasComponents/addCinema.vue